import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8 bg-white dark:bg-[#0c1427] rounded-md m-4" }
const _hoisted_2 = { class: "text-2xl font-bold mb-6 text-black dark:text-white" }
const _hoisted_3 = { class: "grid gap-4 mb-8" }
const _hoisted_4 = { class: "p-4 bg-gray-50 dark:bg-[#15203c] rounded-md" }
const _hoisted_5 = { class: "mb-2 font-semibold" }
const _hoisted_6 = { class: "flex space-x-4" }
const _hoisted_7 = { class: "p-4 bg-gray-50 dark:bg-[#15203c] rounded-md" }
const _hoisted_8 = { class: "text-xl font-semibold mb-3 text-black dark:text-white" }
const _hoisted_9 = { class: "grid gap-3" }
const _hoisted_10 = { class: "text-black dark:text-white" }
const _hoisted_11 = { class: "text-black dark:text-white" }
const _hoisted_12 = { class: "text-black dark:text-white" }
const _hoisted_13 = { class: "text-black dark:text-white" }
const _hoisted_14 = { class: "text-black dark:text-white" }
const _hoisted_15 = { class: "text-black dark:text-white" }
const _hoisted_16 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('dashboard.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('common.chooseLanguage')) + ":", 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en'))),
            class: _normalizeClass(["px-4 py-2 rounded-md", _ctx.currentLanguage === 'en' ? 'bg-primary-500 text-white' : 'bg-gray-200 dark:bg-[#172036] text-black dark:text-white'])
          }, " English ", 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('he'))),
            class: _normalizeClass(["px-4 py-2 rounded-md", _ctx.currentLanguage === 'he' ? 'bg-primary-500 text-white' : 'bg-gray-200 dark:bg-[#172036] text-black dark:text-white'])
          }, " עברית ", 2),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('ar'))),
            class: _normalizeClass(["px-4 py-2 rounded-md", _ctx.currentLanguage === 'ar' ? 'bg-primary-500 text-white' : 'bg-gray-200 dark:bg-[#172036] text-black dark:text-white'])
          }, " العربية ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('dashboard.welcome')), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('navbar.notifications')), 1),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('navbar.messages')), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.directT('common.rtlMode')) + ": " + _toDisplayString(_ctx.isRtl ? 'Enabled' : 'Disabled'), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('common.search')), 1),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('dashboard.sales')) + ": 1,245", 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('dashboard.revenue')) + ": $12,345", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleDirection && _ctx.toggleDirection(...args))),
        class: "inline-flex items-center px-4 py-2 border border-primary-500 text-primary-500 rounded-md hover:bg-primary-500 hover:text-white transition-colors duration-300"
      }, _toDisplayString(_ctx.directT('common.rtlMode')), 1)
    ])
  ]))
}